// @flow
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { compose } from "recompose";
import { Row, Icon, Col, Card } from "antd";
import * as actions from "../../actions";
import { withLoading } from "../hoc";
import type { Entities } from "../../types/entities";
import "./home.css";

type Props = {
  entities: Entities,
  onSetType: Function
};

let Home = ({ entities, onSetType }: Props) => {
  return (
    <Row className="home padding-for-nav">
      {entities.all.map(_id => {
        const { id, name, description, icon } = entities.byId[_id];
        return (
          <Col key={id} xs={24} sm={12} lg={6} style={{ padding: "15px 8px" }}>
            <a onClick={() => onSetType(id)}>
              <Card style={{ display: "block" }}>
                <div className="custom-image">
                  <Icon className="icon" type={icon} />
                </div>
                <div className="custom-card">
                  <h3>{name}</h3>
                  <div
                    className="description"
                    title={description.replace(/<\/?[^>]+(>|$)/g, "")}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>
              </Card>
            </a>
          </Col>
        );
      })}
    </Row>
  );
};

const loadingCondition = props => props.isLoading;

Home = compose(withLoading(loadingCondition))(Home);

const mapStateToProps = state => {
  const { entities } = state.filters.mainFilters.typologies;
  const { isLoading } = state.filters.mainFilters;
  return {
    entities,
    isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetType: id => {
      const ids = [id];
      dispatch(actions.setTypology(ids));
      dispatch(push("/search"));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

Home.propTypes = {
  entities: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSetType: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/home/index.js